import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export const useGetTranslatedEnumOptions = (
  enumValues: readonly string[]
): Array<{ value: string; label: string }> => {
  const { t } = useTranslation(["communicationStudio"])
  const ENUM_TRANSLATION_KEYS = useMemo(
    () =>
      ({
        // Text Transform
        none: t("tabs.design.enums.textTransform.none"),
        capitalize: t("tabs.design.enums.textTransform.capitalize"),
        uppercase: t("tabs.design.enums.textTransform.uppercase"),
        lowercase: t("tabs.design.enums.textTransform.lowercase"),

        // Text Decoration
        underline: t("tabs.design.enums.textDecoration.underline"),
        overline: t("tabs.design.enums.textDecoration.overline"),
        "line-through": t("tabs.design.enums.textDecoration.lineThrough"),

        // Alignment
        left: t("tabs.design.enums.align.left"),
        right: t("tabs.design.enums.align.right"),
        center: t("tabs.design.enums.align.center"),
        start: t("tabs.design.enums.align.start"),
        end: t("tabs.design.enums.align.end"),

        // Flex Alignment
        "flex-start": t("tabs.design.enums.flexAlign.flexStart"),
        "flex-end": t("tabs.design.enums.flexAlign.flexEnd"),
      }) as const,
    [t]
  )
  return enumValues.map((value) => ({
    value,
    label:
      ENUM_TRANSLATION_KEYS[value as keyof typeof ENUM_TRANSLATION_KEYS] ??
      value,
  }))
}
